import { useProductShellNavigationContext } from "../ProductShellNavigationContext";
export type FilterBySearchQuery = (i: { title: string }) => boolean;

export const useGetFilterItemsBySearchQuery = (): FilterBySearchQuery => {
  const navigationContext = useProductShellNavigationContext();

  return (i: { title: string }) =>
    i.title.toLocaleLowerCase().includes(navigationContext.searchQuery?.toLocaleLowerCase() || "");
};
